// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/* 路由 */
import router from './router'
import store from './store'
/* axios */
// import axios from './api'
// import api from './api/api'
// Vue.prototype.http = axios;
// Vue.prototype.api = api;
import BaiduMap from 'vue-baidu-map'
Vue.use(ViewUI).use(ElementUI).use(BaiduMap, {
	ak: '9fCKnEagFIyQMuleRZ7kqAGjhVitaBVZ',
	v: '2.0', // 默认使用3.0
})

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
import './assets/css/main.css'
import './assets/css/common.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
	let company = JSON.parse(localStorage.getItem('company'))
	if (to.meta.title) {
		document.title = to.meta.title + '-' + company.title
	}
	if (to.query.id == 100) {
		document.title = '双路联网充电插座' + '-' + company.title
	} else if (to.query.id == 602) {
		document.title = '16A双路联网充电插座' + '-' + company.title
	} else if (to.query.id == 210) {
		document.title = '10路智能充电站' + '-' + company.title
	} else if (to.query.id == 212) {
		document.title = '12路智能充电站' + '-' + company.title
	} else if (to.query.id == 710) {
		document.title = '交流充电桩' + '-' + company.title
	} else if (to.query.id == 810) {
		document.title = '直流快速充电桩' + '-' + company.title
	} else if (to.query.id == 820) {
		document.title = '智能充/换电柜' + '-' + company.title
	} else if (to.query.id == 910) {
		document.title = '智能充电管理平台' + '-' + company.title
	} else if (to.query.id == 7) {
		document.title = '直营业务' + '-' + company.title
	} else if (to.query.id == 5) {
		document.title = '渠道合作' + '-' + company.title
	} else if (to.query.id == 6) {
		document.title = '增值服务' + '-' + company.title
	} else if (to.query.id == 0) {
		document.title = '公司简介' + '-' + company.title
	} else if (to.query.id == 1) {
		document.title = '公司历程' + '-' + company.title
	} else if (to.query.id == 2) {
		document.title = '公司荣誉' + '-' + company.title
	} else if (to.query.id == 3) {
		document.title = '公司资质' + '-' + company.title
	} else if (to.query.id == 4) {
		document.title = '联系方式' + '-' + company.title
	}
	if (to.meta.content) {
		const head = document.getElementsByTagName('head')[0];
		// 删除现有名称为 "keywords" 和 "description" 的 meta 标签
		const existingKeywordsMeta = document.querySelector('meta[name="keywords"]');
		if (existingKeywordsMeta) {
			existingKeywordsMeta.remove(); // 移除现有的关键词 meta 标签
		}
		const existingDescriptionMeta = document.querySelector('meta[name="description"]');
		if (existingDescriptionMeta) {
			existingDescriptionMeta.remove(); // 移除现有的描述 meta 标签
		}

		// 创建并设置新的关键词和描述 meta 标签
		const keywordsMeta = document.createElement('meta');
		keywordsMeta.setAttribute('name', 'keywords');
		keywordsMeta.setAttribute('content', '"' + company.keyword + '"');
		head.appendChild(keywordsMeta); // 添加新的关键词 meta 标签
		const descriptionMeta = document.createElement('meta');
		descriptionMeta.setAttribute('name', 'description');
		descriptionMeta.setAttribute('content', '"' + company.desription + '"');
		head.appendChild(descriptionMeta); // 添加新的描述 meta 标签

		// 可选：如果需要，更新名为 "content" 的其他 meta 标签
		const contentMeta = document.querySelector('meta[name="content"]');
		if (contentMeta) {
			contentMeta.setAttribute('content', to.meta.content); // 更新 content 属性
		}


	}
	next();
});

new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js